import { UserModuleConfiguration } from '@user/configuration';

import { UserPageName } from '@user/ui/UserPage/types';

const userPages = new Set<UserPageName>([
    UserPageName.UserProfile,
    UserPageName.ScheduleSettings,
    UserPageName.SiteProfile,
    UserPageName.Prices,
    UserPageName.Notifications,
]);

export const userModule: UserModuleConfiguration = {
    userPages,
};
